hero = {};

hero = {
    changeHeader: function(){
        let $data = this.id;
        let $buttons = $('.js-btnKnowUs');

        $buttons.removeClass("isSelected");
        $buttons.find('.text').removeClass("isSelected");

        let $dataSection = $('.hero-data-block');
        $dataSection.find('.right').removeClass("isSelected");

        $(this).addClass("isSelected");
        $(this).find('.text').addClass("isSelected");
        $dataSection.find('[data-section="'+$data+'"]').addClass("isSelected");
    },
	binds: function () {
		$('button').on('click', this.changeHeader);
	}
}

$(document).ready(function () {
    hero.binds();
});